// extracted by mini-css-extract-plugin
export var caption = "styles-module--caption--a2631";
export var credit = "styles-module--credit--18194";
export var image = "styles-module--image--e117b";
export var imageContainer = "styles-module--imageContainer--bc1ce";